export const findAndMakeEmailsInText = (text: string) => {
  const mailRegex =
  /(([^<>()[\]\\.,;:\s@\\"]+(\.[^<>()[\]\\.,;:\s@\\"]+)*)|(\\".+\\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;

  return text.replace(
    mailRegex,
    (mail) => `<a href="mailto:${mail}">${mail}</a>`
  );
};